import { types } from './actions';


const initialState = {
  currentJobId: null,
  currentTicketId: null,
  currentDepartmentId: null,
  currentDistrictId: null,
};


const fieldAdminReview = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_DISTRICT_ID: {
      const { currentDistrictId } = action;
      return {
        ...state,
        currentDistrictId,
      };
    }
    case types.SELECT_DEPARTMENT_ID: {
      const { currentDepartmentId } = action;
      return {
        ...state,
        currentDepartmentId,
      };
    }
    case types.SELECT_JOB_ID: {
      const { currentJobId } = action;
      if (currentJobId === state.currentJobId) {
        return state;
      }
      return {
        ...state,
        currentJobId,
        currentTicketId: null,
      };
    }
    case types.SELECT_TICKET_ID: {
      const { currentTicketId } = action;
      return {
        ...state,
        currentTicketId,
      };
    }
    default:
      return state;
  }
};


export default fieldAdminReview;
